import { render } from "./ResourceSpecsComponent.vue?vue&type=template&id=5efbf798&scoped=true"
import script from "./ResourceSpecsComponent.vue?vue&type=script&lang=js"
export * from "./ResourceSpecsComponent.vue?vue&type=script&lang=js"

import "./ResourceSpecsComponent.vue?vue&type=style&index=0&id=5efbf798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efbf798"]])

export default __exports__